import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

export type SummaryTitleProps = {
  title: string;
};

export const SummaryTitle = ({ title }: SummaryTitleProps) => {
  return (
    <Font variant="h5" style={{ paddingBottom: '6px' }} color="title">
      <Text strong tId={title} />
    </Font>
  );
};
